import breakpoints from "../../../../../../styles/common/breakpoints.js";
export const defaultWidth = 348;
export const skins = {
    1: {
        height: [
            385,
            335,
            345,
            335,
            415,
            315,
            395,
            355,
            315
        ],
        perPage: 3,
        perMove: 3,
        breakpoints: {
            [breakpoints.md]: {
                perPage: 2,
                perMove: 2
            },
            [breakpoints.lg]: {
                perPage: 3,
                perMove: 3
            }
        }
    },
    2: {
        height: [
            385,
            335,
            345,
            335,
            415,
            315,
            395,
            355,
            315,
            335,
            315,
            415
        ],
        perPage: 4,
        perMove: 4,
        breakpoints: {
            [breakpoints.md]: {
                perPage: 2,
                perMove: 2
            },
            [breakpoints.lg]: {
                perPage: 3,
                perMove: 3
            },
            [breakpoints.xl]: {
                perPage: 4,
                perMove: 4
            }
        }
    },
    3: {
        height: [
            265,
            225,
            225,
            265,
            305,
            185,
            265,
            225
        ],
        perPage: 4,
        perMove: 4,
        breakpoints: {
            [breakpoints.md]: {
                perPage: 2,
                perMove: 2
            },
            [breakpoints.lg]: {
                perPage: 3,
                perMove: 3
            },
            [breakpoints.xl]: {
                perPage: 4,
                perMove: 4
            }
        }
    }
};

//# sourceMappingURL=constants.js.map